import { Box, Button } from '@mui/material'
import type React from 'react'
import { useContext, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { LanguageContext } from '../util/LanguageContext'
import { ConversationModalDelDialogSmart } from './ConversationModalDelDialogSmart'

type ConversationDelButtonProps = {
  text: string
  onClick: () => void
  onDel: () => void
}

export const ConversationDelButton: React.FC<ConversationDelButtonProps> = props => {
  // 文字列変換用
  const translation = useContext(LanguageContext)
  const [open, setOpen] = useState(false)
  const auth = useAuth()
  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const onClickHandler = async () => {
    handleOpen()
  }

  return (
    <>
      <Box display="flex" justifyContent="center" mt={2} mb={2}>
        {open && (
          <ConversationModalDelDialogSmart
            open={open}
            text={props.text}
            onClose={handleClose}
            onDel={props.onDel}
          />
        )}
        <Button
          // disabled={auth.isDisable}
          onClick={onClickHandler}
          sx={{
            color: '#FFFFFF',
            font: 'normal normal bold 16px/23px Noto Sans JP',
            textAlign: 'center',
            backgroundColor: '#FF0000',
            '&:hover': {
              color: '#FFFFFF',
              backgroundColor: '#FF0000',
              opacity: 0.8,
            },
            boxShadow: '0px 2px 2px #00000014',
            height: '37px',
            width: '150px',
            borderRadius: '6px',
          }}
        >
          {translation['button_delete']}
        </Button>
      </Box>
    </>
  )
}
